import { render } from "./DeleteDeviceModal.vue?vue&type=template&id=8e068c18&scoped=true&ts=true"
import script from "./DeleteDeviceModal.vue?vue&type=script&lang=ts"
export * from "./DeleteDeviceModal.vue?vue&type=script&lang=ts"

import "./DeleteDeviceModal.vue?vue&type=style&index=0&id=8e068c18&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8e068c18"]])

export default __exports__